export const STATUS_ENUM = [
    {
        name: 'Completed',
        value: 'SUCCESS',
    },
    {
        name: 'Failed',
        value: 'FAILURE',
    },
    {
        name: 'Pending',
        value: 'IN_PROGRESS',
    },
];

export const SECTION_LIST_ENUM = [
    {
        name: 'Merchant Detail',
        value: 'MERCHANT_SECTION',
    },
    {
        name: 'Integration',
        value: 'INTEGRATION',
    },
    {
        name: 'Payment Mode',
        value: 'PAYMENTMODE',
    },
    {
        name: 'Settlement',
        value: 'SETTLEMENT_SECTION',
    },
    {
        name: 'PG Configuration',
        value: 'PGCONFIGURATION',
    },
    {
        name: 'Routing',
        value: 'ROUTING_SECTION',
    },
    {
        name: 'Surcharge',
        value: 'SURCHARGE_SECTION',
    },
    {
        name: 'Notification',
        value: 'NOTIFICATION',
    },
];
